// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"truncateTextWithTooltip_tooltip__bC7lS","wrapper":"truncateTextWithTooltip_wrapper__XKhly","tooltipContainer":"truncateTextWithTooltip_tooltipContainer__kxyYR"};